/* eslint-disable */
//tslint:disable

import { IAnswerSchema } from './AnswerSchema';
import { ICheckboxQuestionSchema } from './CheckboxQuestionSchema';
import { IHelpTextSchema } from '../help_text/HelpTextSchema';

export interface IQuestionSchema {
  /** Название поля, под которым будет храниться ответ. Например: «dealType» **/
  answerField: EAnswerField;
  /** Тип ответа. Пример: bool/list/str и т.д. **/
  answerType: EAnswerType;
  /** Варианты ответов, если применимо **/
  answers?: IAnswerSchema[] | null;
  /** Дополнительные вопросы-чекбоксы. Пример: «включая налоги» **/
  checkboxes?: ICheckboxQuestionSchema[] | null;
  /** Код вопроса, его уникальный идентификатор **/
  code: ECode;
  /** Пояснительный текст для вопроса **/
  helpText?: IHelpTextSchema | null;
  /** Надо ли отображать в вопросе иконки/картинки **/
  iconType?: EIconType | null;
  /** Плейсхолдер **/
  placeholder?: string | null;
  /** Заголовок вопроса. Пример: «Чем риелтор может вам помочь?» **/
  title: string;
  /** Тип вопроса. Пример: «one_choice» **/
  type: EType;
  /** Единицы измерения **/
  unit?: string | null;
}

export enum EAnswerField {
  /** Поле для ответа отсутствует **/
  Absent = 'absent',
  /** Укажите адрес **/
  Address = 'address',
  /** Укажите общую площадь **/
  Area = 'area',
  /** Есть, что добавить? **/
  Comment = 'comment',
  /** Как срочно хотите совершить сделку? **/
  DealPeriod = 'dealPeriod',
  /** Чем риелтор может вам помочь? так-то это dealType, только странный **/
  DealTypeEx = 'dealTypeEx',
  /** Введите адрес электронной почты **/
  Email = 'email',
  /** Новостройка или вторичка? **/
  FirstOrSecond = 'firstOrSecond',
  /** Как вас зовут? **/
  FullName = 'fullName',
  /** Включая коммунальные платежи **/
  IncludeCommunal = 'includeCommunal',
  /** Включая эксплуатационные налоги **/
  IncludeOperationalTaxes = 'includeOperationalTaxes',
  /** Объект в залоге у банка? **/
  IsBankDeposit = 'isBankDeposit',
  /** Планируете брать кредит? **/
  IsCredit = 'isCredit',
  /** Вы уже разместили объявление? **/
  IsHasOffer = 'isHasOffer',
  /** Вы получили квартиру в наследство? **/
  IsInheritance = 'isInheritance',
  /** В числе собственников есть несовершеннолетние? **/
  IsMinorOwners = 'isMinorOwners',
  /** Уже накопили на первоначальный взнос? **/
  IsMortgageInitialPayment = 'isMortgageInitialPayment',
  /** Вы готовы снизить цену, в случае необходимости? **/
  IsReadyToLower = 'isReadyToLower',
  /** Уже есть одобрение ипотеки от банка? **/
  MortgageBankApprove = 'mortgageBankApprove',
  /** Уточните тип недвижимости **/
  ObjectType = 'objectType',
  /** Какую недвижимость хотите продать? **/
  OfferType = 'offerType',
  /** Укажите номер мобильного телефона **/
  Phone = 'phone',
  /** Укажите предпочитаемую цену **/
  Price = 'price',
  /** Как планируете покупать квартиру? **/
  PurchaseMethod = 'purchaseMethod',
  /** Срок аренды **/
  RentType = 'rentType',
  /** Укажите количество комнат **/
  RoomCount = 'roomCount',
}
export enum EAnswerType {
  /** Булево поле **/
  Bool = 'bool',
  /** Строковая енамка **/
  Enum = 'enum',
  /** Интовая енамка **/
  IntEnum = 'intEnum',
  /** Список интовых енамок **/
  IntEnumList = 'intEnumList',
  /** Положительное целое число **/
  Integer = 'integer',
  /** Объект с integer полями gte и lte **/
  Range = 'range',
  /** Строка **/
  String = 'string',
}
export enum ECode {
  /** Укажите адрес **/
  Address = 'address',
  /** «Магический шаг», во время которого фронт правит балом **/
  AddressMagic = 'addressMagic',
  /** Укажите общую площадь **/
  Area = 'area',
  /** Укажите общую площадь (от и до) **/
  AreaRange = 'areaRange',
  /** Есть, что добавить? **/
  Comment = 'comment',
  /** Как срочно хотите совершить сделку? 3/6/12 месяцев **/
  DealPeriod = 'dealPeriod',
  /** Чем риелтор может вам помочь? так-то это dealType, только странный **/
  DealTypeEx = 'dealTypeEx',
  /** Введите адрес электронной почты **/
  Email = 'email',
  /** Новостройка или вторичка? **/
  FirstOrSecond = 'firstOrSecond',
  /** Новостройка или вторичка? Или неважно **/
  FirstOrSecondExtended = 'firstOrSecondExtended',
  /** Как вас зовут? **/
  FullName = 'fullName',
  /** Объект в залоге у банка? **/
  IsBankDeposit = 'isBankDeposit',
  /** Планируете брать кредит? **/
  IsCredit = 'isCredit',
  /** Вы уже разместили объявление? **/
  IsHasOffer = 'isHasOffer',
  /** Вы получили квартиру в наследство? **/
  IsInheritance = 'isInheritance',
  /** В числе собственников есть несовершеннолетние? **/
  IsMinorOwners = 'isMinorOwners',
  /** Уже накопили на первоначальный взнос? **/
  IsMortgageInitialPayment = 'isMortgageInitialPayment',
  /** Вы готовы снизить цену, в случае необходимости? **/
  IsReadyToLower = 'isReadyToLower',
  /** Уже есть одобрение ипотеки от банка? **/
  MortgageBankApprove = 'mortgageBankApprove',
  /** Уточните тип недвижимости | Коммерческая **/
  ObjectTypeCommercial = 'objectTypeCommercial',
  /** Уточните тип недвижимости | Коммерческая (с готовым бизнесом) **/
  ObjectTypeCommercialWithBusiness = 'objectTypeCommercialWithBusiness',
  /** Уточните тип недвижимости | Жилая **/
  ObjectTypeFlat = 'objectTypeFlat',
  /** Уточните тип недвижимости | Загородка **/
  ObjectTypeSuburban = 'objectTypeSuburban',
  /** Какую недвижимость хотите продать? **/
  OfferType = 'offerType',
  /** Как срочно хотите совершить сделку? 1/2/4 недели **/
  PeriodShort = 'periodShort',
  /** Укажите номер мобильного телефона **/
  Phone = 'phone',
  /** Укажите предпочитаемую цену **/
  Price = 'price',
  /** Укажите предпочитаемую цену (диапазон) **/
  PriceRange = 'priceRange',
  /** Укажите предпочитаемую цену (диапазон) + включая коммунальные платежи **/
  PriceRangeWithCommunal = 'priceRangeWithCommunal',
  /** Укажите предпочитаемую цену (диапазон) + включая коммунальные платежи + включая эксплуатационные налоги **/
  PriceRangeWithCommunalAndOperational = 'priceRangeWithCommunalAndOperational',
  /** Укажите предпочитаемую цену + включая коммунальные платежи **/
  PriceWithCommunal = 'priceWithCommunal',
  /** Укажите предпочитаемую цену + включая коммунальные платежи + включая эксплуатационные налоги **/
  PriceWithCommunalAndOperational = 'priceWithCommunalAndOperational',
  /** Как планируете покупать квартиру? **/
  PurchaseMethod = 'purchaseMethod',
  /** Уточните срок аренды **/
  RentType = 'rentType',
  /** Укажите количество комнат **/
  RoomCount = 'roomCount',
  /** Укажите количество комнат. Доступен выбор нескольких **/
  RoomsCountMulti = 'roomsCountMulti',
  /** Заявка отправлена **/
  Success = 'success',
}
export enum EIconType {
  /** Иконки **/
  Icon = 'icon',
  /** Картинки **/
  Pictures = 'pictures',
}
export enum EType {
  /** Вопрос с указанием адреса без использования магии на фронте. **/
  Address = 'address',
  /** Вопрос с указанием email. По этому типу будет валидация **/
  Email = 'email',
  /** Вопрос с геосаджестом. По этому типу будет использован гео-саджест **/
  GeoSuggest = 'geoSuggest',
  /** Input. Пользователь сам вбивает строковое значение. **/
  Input = 'input',
  /** Можно выбрать несколько вариантов ответа **/
  MultiChoice = 'multiChoice',
  /** Number. Пользователь сам вбивает числовое значение. **/
  Number = 'number',
  /** Можно выбрать только 1 вариант ответа **/
  OneChoice = 'oneChoice',
  /** Вопрос с указанием номера телефона. По этому типу будет хук на подтверждение номера и валидация **/
  Phone = 'phone',
  /** Вопрос с указанием цены. По этому типу будет хук на запрос оценки и валидация **/
  Price = 'price',
  /** Вопрос, где нужно указать значение от и значение до **/
  Range = 'range',
}
